<div class="panel" [ngClass]="{'active-panel': activePanel.value === 'options'}">
  <div class="panel-heading">
    <h4 class="panel-title">
      Ticket Options
      <span class="fa fa-check-square-o" [ngClass]="{hide: !status.billingSet}"></span>
    </h4>
  </div>
  <div class="panel-body">
    <section [formGroup]="pickOptionsForm" [ngClass]="{'panel callout' : tooManyTickets}">
      @for (price of variant.prices; track price) {
        <section class="prices">
          <div class="row">
            <div class="small-12 columns">
              <div class="row" [ngClass]="{'error' : errors[price.slug] || tooManyTickets}">
                <div class="small-4 columns">
                  <label class="right inline" [for]="price.slug">
                    {{ price.label }} at {{ !!price.price && (price.price / 100 | currency : 'GBP' : 'symbol' : '1.2-2')
                    || 'Free' }}
                  </label>
                </div>
                <div class="small-8 columns">
                  <input type="number" pattern="^\d+$" [formControlName]="price.slug" [id]="price.slug" min="0"
                    (change)="updateTotal()" />
                </div>
              </div>
            </div>
          </div>
        </section>
      }
    </section>
    @for (supplement of variant.supplements; track supplement) {
      <section class="supplements">
        <div class="row">
          <div class="small-12 columns">
            <div class="row" [ngClass]="{'error' : errors[supplement.slug] || tooManySupplements}">
              <div class="small-4 columns">
                <label class="right inline" [for]="supplement.slug">
                  {{ supplement.label }} at {{ !!supplement.price && (supplement.price / 100 | currency : 'GBP' : 'symbol'
                  : '1.2-2') || 'Free' }}
                </label>
              </div>
              <div class="small-8 columns">
                <input type="number" pattern="^\d+$" [formControlName]="supplement.slug" [id]="supplement.slug" min="0"
                  (change)="updateTotal()" />
              </div>
            </div>
          </div>
        </div>
      </section>
    }
    @if (variant.tickets_per_partner) {
      <p
        [ngClass]="{'error' : total.tickets > variant.tickets_per_partner, 'info' : total.tickets <= variant.tickets_per_partner}">
        You are only allowed {{ variant.tickets_per_partner }} ticket{{ variant.tickets_per_partner > 1 ? 's' : '' }} per
        Partner
      </p>
    }
    @if (showHurry) {
      <p class="panel callout warning">
        There {{ variant.stock_quantity == 1 ? 'is' : 'are' }} only {{ variant.stock_quantity }} left to purchase, be
        quick before they're all gone!
      </p>
    }
    <p (click)="showTerms()" style="color: #d4760a; cursor: pointer;">Terms &amp; Conditions</p>
    <div class="full-width">
      <section class="price">
        {{ !isFree && (total.cost / 100 | currency : 'GBP' : 'symbol' : '1.2-2') || 'Free' }}
      </section>
      <button class="button accordion-toggle" (click)="addOptions()" [disabled]="disabled()">
        Add Tickets
      </button>
    </div>
  </div>
</div>